// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"RgYZ2","imageTitle":"_1oTVY","tilesContainer":"_3fzIq","card":"sEa6-","image":"_3jWMO","ctaLabel":"_1WAoo"};